import { createContext, useContext, useEffect, useRef } from 'react';

export const PageTransitionContext = createContext<{
  targets: Map<any, any>;
  queue: any[];
}>({
  targets: new Map(),
  queue: [],
});

export function useTransitionTarget(name: string) {
  const { targets } = useContext(PageTransitionContext);
  const ref = useRef(null);
  useEffect(() => {
    targets.set(name, ref);
  }, []);
  return ref;
}
